var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.092 5.516L8.12 3.5L8.684 4.064L6.668 6.092L8.684 8.12L8.12 8.684L6.092 6.668L4.064 8.684L3.5 8.12L5.516 6.092L3.5 4.064L4.064 3.5L6.092 5.516Z",
    fill: "#C52A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.888 0L8.22 0.0359995C8.42 0.0359995 8.596 0.112 8.748 0.263999L11.784 3.348C11.928 3.492 12 3.672 12 3.888L11.964 8.22C11.964 8.42 11.888 8.596 11.736 8.748L8.652 11.784C8.508 11.928 8.328 12 8.112 12L3.78 11.964C3.58 11.964 3.404 11.888 3.252 11.736L0.216 8.652C0.072 8.508 0 8.328 0 8.112L0.036 3.78C0.036 3.58 0.112 3.404 0.264 3.252L3.348 0.216C3.492 0.072 3.672 0 3.888 0ZM8.21629 0.792961C8.21338 0.790099 8.21086 0.787781 8.20874 0.785932L3.88599 0.750009C3.88107 0.750055 3.87714 0.750266 3.87411 0.750517L0.792986 3.78369C0.790112 3.78661 0.787787 3.78914 0.785932 3.79126L0.750009 8.11401C0.750055 8.11893 0.750266 8.12286 0.750517 8.12589L3.78369 11.207C3.78661 11.2099 3.78914 11.2122 3.79126 11.2141L8.11401 11.25C8.11893 11.2499 8.12287 11.2497 8.12589 11.2495L11.2071 8.21628C11.2099 8.21337 11.2122 8.21085 11.2141 8.20874L11.25 3.88599C11.2499 3.88107 11.2497 3.87713 11.2495 3.87411L8.21629 0.792961Z",
    fill: "#C52A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d65f673d2ff4e20b5ea2bdf41420edbe.svg";
export { ForwardRef as ReactComponent };